import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-describedby": "calendar-list-table-description",
  class: "table table-borderless table-responsive-sm table-sm"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Title"),
    /*#__PURE__*/_createElementVNode("th", { width: "100px" }, "Weight"),
    /*#__PURE__*/_createElementVNode("th", { width: "100px" }, "Actions")
  ])
], -1)
const _hoisted_3 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Actions"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("em", { class: "fa fa-edit" }, null, -1)

import { EVENT_NAME__CALENDAR_NOT_REMOVED, EVENT_NAME__CALENDAR_REMOVED } from '@/api/CalendarsApi'
import ListManager, { BaseData, BaseLock } from '@/uiManagers/ListManager'
import { Calendar, ListResponse, Query, Uuid } from '@/types/api'
import { inject, onBeforeMount, reactive, ref } from 'vue'
import { calendarsApi } from '@/di/api'
import eventBus from '@/di/eventBus'
import { notifyInjectionKey } from '@/keys'
import { useRouter } from "vue-router";
import { Notify } from "@/types/app";
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";
import AppEmptyListAlert from "@/components/app/AppEmptyListAlert.vue";
import AppIconLoadingButton from "@/components/app/AppIconLoadingButton.vue";
import AppIcon from "@/components/app/AppIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarsList',
  setup(__props) {

class CalendarListManager extends ListManager<Calendar, Query, BaseLock, BaseData<Calendar>> {

}

const router = useRouter()

const model = ref<Query>({ paging: { page: 1, per_page: 10 } })
const lock = reactive<BaseLock>({ itemsLoading: false, removingId: null })
const data = reactive<BaseData<Calendar>>({ presentation: { items: [], total_count: 0 } })

const calendarListManager = new CalendarListManager(
    router,
    inject(notifyInjectionKey) as Notify,
    eventBus,
    model,
    lock,
    data,
    (): Promise<ListResponse<Calendar>> => {
      return calendarsApi.getCalendars()
    },
    (itemId: Uuid): Promise<void> => calendarsApi.removeCalendar(itemId),
    {
      removed: EVENT_NAME__CALENDAR_REMOVED,
      notRemoved: EVENT_NAME__CALENDAR_NOT_REMOVED
    },
    ((event: { calendar_id: Uuid }): Uuid => event.calendar_id) as (event: object) => Uuid
)

const removeItem = async (itemId: Uuid): Promise<void> => {
  await calendarListManager.removeItem(itemId)
}

onBeforeMount(async (): Promise<void> => {
  await calendarListManager.prepare()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_router_link, {
        to: {name: 'calendar-create'},
        class: "btn btn-primary btn-sm"
      }, {
        default: _withCtx(() => [
          _createVNode(AppIcon, { icon: "plus" }),
          _createTextVNode(" Add new calendar ")
        ]),
        _: 1
      })
    ]),
    (data.presentation.items.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.presentation.items, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [
                _createElementVNode("td", null, _toDisplayString(item.title), 1),
                _createElementVNode("td", null, _toDisplayString(item.weight), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_3, [
                    (!item.is_default)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "btn btn-primary btn-sm",
                          to: {name: 'calendar-edit', params: {id: item.id}}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (!item.is_default)
                      ? (_openBlock(), _createBlock(AppIconLoadingButton, {
                          key: 1,
                          loading: lock.removingId === item.id,
                          icon: "trash",
                          "button-type": "danger",
                          "button-small": true,
                          disabled: !!lock.removingId,
                          onClick: ($event: any) => (removeItem(item.id))
                        }, null, 8, ["loading", "disabled", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (lock.itemsLoading)
        ? (_openBlock(), _createBlock(AppLoadingMessage, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("Loading calendar list")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(AppEmptyListAlert, { key: 2 }, {
            default: _withCtx(() => [
              _createTextVNode("No calendar present")
            ]),
            _: 1
          }))
  ], 64))
}
}

})